<template>
  <div class="HomePage">
    <div class="index0box">
      <img src="@/assets/img/index/index0.png">
      <div class="linkBox">
        <div v-if="dateLine">
          <a href="#" class="d-flex" @click="$addTags(tags.formPage,null,null,{path:'/fromPage' })">
            <v-img contain :eager=true class="justify-center" src="../assets/img/index/btnBill.svg" width="80%" />
          </a>
          <br>
          <a href='#' class="d-flex" @click="$addTags(tags.friendPage,null,null,{path:'/friendPage'})">
            <v-img contain :eager=true class="justify-center" src="../assets/img/index/btnFriend.svg" width="80%" />
          </a>
        </div>
        <div v-else class="endBtn">活動已結束</div>
      </div>
    </div>
    <img src="@/assets/img/index/index1.png">
    <img id="prize" src="@/assets/img/index/index2.png">
    <img id="gift" src="@/assets/img/index/index3.png">
    <router-link to="/winnerPage" @click.native="$addTags(tags.formPage,null,null,null)">
      <img id="winning" src="@/assets/img/index/index4.png" width="100%">
      </router-link> 
    <img id="illustrate" src="@/assets/img/index/index5.png">
    <div class="box">
      <a href="https://www.facebook.com/andante.clc/" target="_blank">
        <img src="@/assets/img/index/index6.png"></a>
      <img class="img2" src="@/assets/img/index/index7.png">
      <img class="img3" src="@/assets/img/index/index8.png">
      <img class="img4" src="@/assets/img/index/index9.png">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HomePage',
    data() {
      return {
        dateLine: new Date() < new Date('2022-12-1,23:59:59'), //活動結束時間
        tags: {
          "formPage": "0644E166C5084687BDC6E00DC4A1B3D7",
          "friendPage": "7C22FF77F44A43D4AC757B3A501A854F"
        }
      }
    },
    mounted() {

    },
    methods: {
      // 顯示popup視窗
      seePopUp(val) {
        this.dialog = true
        this.popupIconType = 'icon' + val
        this.popupItem = val
      },
    }
  }
</script>
<style lang="scss">
  .HomePage {
    position: relative;

    .endBtn {
      border-radius: 20px;
      background-image: linear-gradient(to bottom, #C35238, #EA765B);
      width: 60%;
      padding: 8px;
      text-align: center;
      color: #ffffff;
      font-weight: 700;
      letter-spacing: 2px;
      font-size: 20px;
    }

    >img {
      width: 100%;
      margin-top: -7px;
    }

    .index0box {
      position: relative;

      img {
        width: 100%;
      }

      .linkBox {
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 5%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        a {
          width: 100%;
        }
      }
    }

    .box {
      background-color: #EBD559;
      width: 100%;

      a {
        position: relative;
        top: -0px;

        &+img {
          top: -14px;
        }
      }

      img {
        position: relative;
        top: -7px;
        width: 100%;
      }

      .img2 {
        top: -21px;
      }

      .img3 {
        top: -28px;
      }

      .img4 {
        top: -35px;
      }
    }
  }
</style>